import useCreateDamageReportHook from "./use-create-damage-report-hook";
import useDamageFilterHook from "./use-damage-filter-hook";


const DamageHooks = {
    useCreateDamageReport: useCreateDamageReportHook,
    useFilter: useDamageFilterHook
}

export default DamageHooks;